module.exports = __webpack_public_path__ + "media/loader-dc955571.gif";